import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, Youtube } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-navy-900 text-white pt-16 pb-8" data-id="element-329">
      <div className="container mx-auto px-4 md:px-8" data-id="element-330">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-331">
          {/* Company Info */}
          <div data-id="element-332">
            <h3 className="text-xl font-bold mb-4 flex items-center" data-id="element-333">
              Kembara Ustaz
              <span className="text-gold-500 ml-1" data-id="element-334">✈</span>
            </h3>
            <p className="text-gray-300 mb-4" data-id="element-335">
              Your trusted travel companion for meaningful and enriching
              journeys. Specializing in Umrah, international tours, and ASEAN
              travel experiences.
            </p>
            <div className="flex space-x-4" data-id="element-336">
              <a href="#" className="text-gray-300 hover:text-gold-500" data-id="element-337">
                <Facebook size={20} data-id="element-338" />
              </a>
              <a href="#" className="text-gray-300 hover:text-gold-500" data-id="element-339">
                <Instagram size={20} data-id="element-340" />
              </a>
              <a href="#" className="text-gray-300 hover:text-gold-500" data-id="element-341">
                <Twitter size={20} data-id="element-342" />
              </a>
              <a href="#" className="text-gray-300 hover:text-gold-500" data-id="element-343">
                <Youtube size={20} data-id="element-344" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-345">
            <h3 className="text-lg font-bold mb-4" data-id="element-346">Quick Links</h3>
            <ul className="space-y-2" data-id="element-347">
              <li data-id="element-348">
                <Link to="/" className="text-gray-300 hover:text-gold-500" data-id="element-349">
                  Home
                </Link>
              </li>
              <li data-id="element-350">
                <Link to="/about" className="text-gray-300 hover:text-gold-500" data-id="element-351">
                  About KU
                </Link>
              </li>
              <li data-id="element-352">
                <Link to="/umrah" className="text-gray-300 hover:text-gold-500" data-id="element-353">
                  UmrahKU
                </Link>
              </li>
              <li data-id="element-354">
                <Link to="/wisata" className="text-gray-300 hover:text-gold-500" data-id="element-355">
                  WisataKU
                </Link>
              </li>
              <li data-id="element-356">
                <Link to="/shop" className="text-gray-300 hover:text-gold-500" data-id="element-357">
                  ShopKU
                </Link>
              </li>
              <li data-id="element-358">
                <Link to="/private" className="text-gray-300 hover:text-gold-500" data-id="element-359">
                  Private Tours
                </Link>
              </li>
              <li data-id="element-360">
                <Link to="/corporate" className="text-gray-300 hover:text-gold-500" data-id="element-361">
                  Corporate
                </Link>
              </li>
            </ul>
          </div>
          {/* Contact Info */}
          <div data-id="element-362">
            <h3 className="text-lg font-bold mb-4" data-id="element-363">Contact Us</h3>
            <ul className="space-y-3" data-id="element-364">
              <li className="flex items-start" data-id="element-365">
                <Phone size={18} className="mr-2 mt-1 text-gold-500" data-id="element-366" />
                <span data-id="element-367">+65 6721 3357</span>
              </li>
              <li className="flex items-start" data-id="element-368">
                <Mail size={18} className="mr-2 mt-1 text-gold-500" data-id="element-369" />
                <span data-id="element-370">info@kembarauztaz.com</span>
              </li>
              <li className="flex items-start" data-id="element-371">
                <MapPin size={18} className="mr-2 mt-1 text-gold-500" data-id="element-372" />
                <span data-id="element-373">
                  123 Travel Street, #01-45
                  <br data-id="element-374" />
                  Singapore 123456
                </span>
              </li>
            </ul>
          </div>
          {/* Office Hours */}
          <div data-id="element-375">
            <h3 className="text-lg font-bold mb-4" data-id="element-376">Office Hours</h3>
            <ul className="space-y-2" data-id="element-377">
              <li className="flex justify-between" data-id="element-378">
                <span data-id="element-379">Monday - Friday:</span>
                <span data-id="element-380">9:00 AM - 6:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-381">
                <span data-id="element-382">Saturday:</span>
                <span data-id="element-383">10:00 AM - 4:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-384">
                <span data-id="element-385">Sunday:</span>
                <span data-id="element-386">Closed</span>
              </li>
              <li className="flex justify-between mt-2" data-id="element-387">
                <span data-id="element-388">Public Holidays:</span>
                <span data-id="element-389">Closed</span>
              </li>
            </ul>
          </div>
        </div>
        {/* Bottom Footer */}
        <div className="pt-8 border-t border-navy-800 text-center text-sm text-gray-400" data-id="element-390">
          <p data-id="element-391">
            © {new Date().getFullYear()} Kembara Ustaz. All rights reserved.
          </p>
          <div className="mt-2 flex justify-center space-x-4" data-id="element-392">
            <Link to="/terms" className="hover:text-gold-500" data-id="element-393">
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="hover:text-gold-500" data-id="element-394">
              Privacy Policy
            </Link>
            <Link to="/faq" className="hover:text-gold-500" data-id="element-395">
              FAQ
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;